import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MediaLibraryHttpService } from 'src/app/http/media-library-http.service';
import { EventsService } from 'src/app/services/events.service';
import { Utilities } from 'src/app/services/utilities';

@Component({
    selector: 'app-edit-asset-modal',
    templateUrl: './edit-asset-modal.component.html',
    styles: [],
})
export class EditAssetModalComponent implements OnInit {
    constructor(
        public activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private mediaLibraryHttpService: MediaLibraryHttpService,
        private eventsServices: EventsService
    ) {}

    editAssetForm = this.fb.group(
        {
            assetId: [null],
            assetName: [null, Validators.required],
        },
        { updateOn: 'submit' }
    );

    formBusy: boolean;

    alert: any;

    ngOnInit(): void {}

    patchForm(assetName: string, assetId: number) {
        this.editAssetForm.controls['assetName'].setValue(assetName);
        this.editAssetForm.controls['assetId'].setValue(assetId);
    }

    onSubmit() {
        this.editAssetForm.markAsTouched();
        if (this.editAssetForm.valid) {
            const check = Utilities.checkImageExtension(this.editAssetForm.value.assetName);

            if (!check) {
                this.editAssetForm.setErrors({ fileType: true });
                return false;
            }

            this.formBusy = true;
            this.mediaLibraryHttpService.editAsset(this.editAssetForm.value.assetName, this.editAssetForm.value.assetId).subscribe((data) => {
                this.eventsServices.trigger.next({ name: 'refreshAssets', value: null });
                this.activeModal.close();
            });
        }
    }
}
